import { useState, useEffect } from 'react';

const navLinks = [
  { label: 'Home', href: '#home' },
  { label: 'About', href: '#about' },
  { label: 'The Book', href: '#book' },
  { label: 'Excerpt', href: '#excerpt' },
  { label: 'Reviews', href: '#reviews' },
  { label: 'Contact', href: '#contact' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [active, setActive] = useState('#home');

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleNav = (href: string) => {
    setActive(href);
    setMenuOpen(false);
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <header
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-400 ${
        scrolled
          ? 'bg-stone-950/95 backdrop-blur-md shadow-md'
          : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 md:px-10 flex items-center justify-between h-16 md:h-20">
        {/* Logo / Name */}
        <a
          href="#home"
          onClick={() => handleNav('#home')}
          className="flex flex-col cursor-pointer"
        >
          <span className="text-amber-300 font-serif text-lg md:text-xl font-bold leading-tight tracking-wide">
            Kevin Hamlett
          </span>
          <span className="text-stone-400 text-xs tracking-widest uppercase">
            Author
          </span>
        </a>

        {/* Desktop Nav */}
        <nav className="hidden md:flex items-center gap-1">
          {navLinks.map((link) => (
            <button
              key={link.href}
              onClick={() => handleNav(link.href)}
              className={`px-4 py-2 rounded-full text-sm font-medium transition-all duration-200 cursor-pointer whitespace-nowrap ${
                active === link.href
                  ? 'text-amber-300 bg-amber-300/10'
                  : scrolled
                  ? 'text-stone-300 hover:text-amber-300 hover:bg-amber-300/10'
                  : 'text-white/80 hover:text-amber-300 hover:bg-white/10'
              }`}
            >
              {link.label}
            </button>
          ))}
        </nav>

        {/* CTA */}
        <div className="hidden md:flex items-center gap-3">
          <a
            href="https://www.amazon.com/dp/B0GT29CWSG"
            target="_blank"
            rel="noopener noreferrer"
            className="text-sm font-semibold px-5 py-2 rounded-full bg-amber-500 hover:bg-amber-400 text-stone-950 transition-all cursor-pointer whitespace-nowrap"
          >
            Get the Book
          </a>
        </div>

        {/* Mobile Hamburger */}
        <button
          className="md:hidden flex items-center justify-center w-9 h-9 cursor-pointer"
          onClick={() => setMenuOpen(!menuOpen)}
        >
          <i
            className={`${menuOpen ? 'ri-close-line' : 'ri-menu-3-line'} text-2xl ${
              scrolled ? 'text-stone-200' : 'text-white'
            }`}
          ></i>
        </button>
      </div>

      {/* Mobile Menu */}
      {menuOpen && (
        <div className="md:hidden bg-stone-950 border-t border-stone-800 px-4 py-4 flex flex-col gap-1">
          {navLinks.map((link) => (
            <button
              key={link.href}
              onClick={() => handleNav(link.href)}
              className="text-left px-4 py-3 rounded-lg text-sm font-medium text-stone-300 hover:bg-amber-500/10 hover:text-amber-300 transition-all cursor-pointer"
            >
              {link.label}
            </button>
          ))}
          <div className="mt-3 pt-3 border-t border-stone-800">
            <a
              href="https://www.amazon.com/dp/B0GT29CWSG"
              target="_blank"
              rel="noopener noreferrer"
              className="block text-center text-sm font-semibold px-5 py-2.5 rounded-full bg-amber-500 hover:bg-amber-400 text-stone-950 transition-all cursor-pointer"
            >
              Get the Book
            </a>
          </div>
        </div>
      )}
    </header>
  );
}
